module.exports = __webpack_public_path__ + "img/dollarama.aa0baffa.jpg";